import { postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";

const short_term_tool = apiUrl + "/short_term_tool";
const routes = {
  label: "Short Term Tool",
  new: short_term_tool + "/new",

  update_stt_by_supply_chain: short_term_tool + "/update_stt_by_supply_chain",
  update_stt_by_corporate: short_term_tool + "/update_stt_by_corporate",
  update_stt_by_structure: short_term_tool + "/update_stt_by_structure",

  get_by_supply_chain_id: short_term_tool + "/get_by_supply_chain_id",
  get_by_corporate_id: short_term_tool + "/get_by_corporate_id",
  get_by_structure_id: short_term_tool + "/get_by_structure_id",
};

export const ShortTermTool = {
  label: routes.label,
  new: (short_term_tool) => postWithToken(routes.new, short_term_tool),

  update_stt_by_supply_chain: (short_term_tool) => postWithToken(routes.update_stt_by_supply_chain, short_term_tool),
  update_stt_by_corporate: (short_term_tool) => postWithToken(routes.update_stt_by_corporate, short_term_tool),
  update_stt_by_structure: (short_term_tool) => postWithToken(routes.update_stt_by_structure, short_term_tool),

  get_by_supply_chain_id: (supply_chain_id) => postWithToken(routes.get_by_supply_chain_id, { supply_chain_id }),
  get_by_corporate_id: (corporate_id) => postWithToken(routes.get_by_corporate_id, { corporate_id }),
  get_by_structure_id: (structure_id) => postWithToken(routes.get_by_structure_id, { structure_id }),
};
